export const storageConfig = {
    STORAGE_DOWNLOAD: 'hs-filestore.dev-helloself.com',
    STORAGE_UPLOAD: 'hs-filestore-upload.dev-helloself.com',
    ACTIVITIES_DOWNLOAD: 'hs-activities.dev-helloself.com',
};

const configureStorage = (API_STAGE: string) => {
    switch (API_STAGE) {
        case 'production':
            storageConfig.STORAGE_DOWNLOAD = 'hs-filestore.helloself.com';
            storageConfig.STORAGE_UPLOAD = 'hs-filestore-upload.helloself.com';
            storageConfig.ACTIVITIES_DOWNLOAD = 'hs-activities.helloself.com';
            break;
        case 'staging':
            storageConfig.STORAGE_DOWNLOAD = 'hs-filestore.test-helloself.com';
            storageConfig.STORAGE_UPLOAD = 'hs-filestore-upload.test-helloself.com';
            storageConfig.ACTIVITIES_DOWNLOAD = 'hs-activities.test-helloself.com';
            break;

        default:
    }
};

export default configureStorage;
